<div>
    @if (metricsLoadError) {
        <div class="alert alert-warning py-2 small" role="alert">Dashboard metrics could not be loaded. Try refreshing the page.</div>
    }

    <div class="row g-3 mb-3">
        <div class="col-6 col-lg-2">
            <div class="card h-100 border-primary border-opacity-25">
                <div class="card-body py-3">
                    <div class="text-muted small text-uppercase">Total reports</div>
                    <div class="fs-3 fw-semibold">{{ metrics.kpi.totalReports }}</div>
                </div>
            </div>
        </div>
        <div class="col-6 col-lg-2">
            <div class="card h-100 border-primary border-opacity-25">
                <div class="card-body py-3">
                    <div class="text-muted small text-uppercase">This month</div>
                    <div class="fs-3 fw-semibold">{{ metrics.kpi.reportsThisMonth }}</div>
                </div>
            </div>
        </div>
        <div class="col-6 col-lg-2">
            <div class="card h-100 border-primary border-opacity-25">
                <div class="card-body py-3">
                    <div class="text-muted small text-uppercase">Last 30 days</div>
                    <div class="fs-3 fw-semibold">{{ metrics.kpi.reportsLast30Days }}</div>
                </div>
            </div>
        </div>
        <div class="col-6 col-lg-2">
            <div class="card h-100 border-warning border-opacity-50">
                <div class="card-body py-3">
                    <div class="text-muted small text-uppercase">DOT accidents</div>
                    <div class="fs-3 fw-semibold text-warning">{{ metrics.kpi.dotAccidents }}</div>
                </div>
            </div>
        </div>
        <div class="col-6 col-lg-2">
            <div class="card h-100 border-danger border-opacity-50">
                <div class="card-body py-3">
                    <div class="text-muted small text-uppercase">With injuries</div>
                    <div class="fs-3 fw-semibold text-danger">{{ metrics.kpi.reportsWithInjuries }}</div>
                </div>
            </div>
        </div>
        <div class="col-6 col-lg-2">
            <div class="card h-100 border-info border-opacity-50">
                <div class="card-body py-3">
                    <div class="text-muted small text-uppercase">Police involved</div>
                    <div class="fs-3 fw-semibold">{{ metrics.kpi.policeInvolvedCount }}</div>
                </div>
            </div>
        </div>
    </div>

    <div class="row g-3">
        <div class="col-lg-6">
            <div class="card h-100">
                <div class="card-body">
                    <h5 class="card-title">Reports by month</h5>
                    <p class="small text-muted">Accident reports over the last 6 months.</p>
                    @if (metrics.monthlyCounts.length === 0) {
                        <p class="text-muted small mb-0">No reports in this period.</p>
                    } @else {
                        <div class="d-flex align-items-end gap-1 aar-bar-wrap">
                            @for (m of metrics.monthlyCounts; track m.label) {
                                <div class="flex-fill text-center">
                                    <div class="aar-bar rounded-top" [style.height.px]="(m.count / maxMonthlyCount()) * 120 || 4" [title]="m.label + ': ' + m.count"></div>
                                    <div class="small text-muted mt-1">{{ m.label }}</div>
                                    <div class="small fw-semibold">{{ m.count }}</div>
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>
        </div>

        <div class="col-lg-6">
            <div class="card h-100">
                <div class="card-body">
                    <h5 class="card-title">DOT classification</h5>
                    <p class="small text-muted">Breakdown of DOT vs Non-DOT accidents.</p>
                    @if (dotTotal() === 0) {
                        <p class="text-muted small mb-0">No reports recorded yet.</p>
                    } @else {
                        <ul class="list-unstyled mb-0">
                            <li class="d-flex justify-content-between border-bottom py-1">
                                <span>DOT</span>
                                <span class="fw-semibold">{{ metrics.dotSplit.dotCount }}</span>
                            </li>
                            <li class="d-flex justify-content-between border-bottom py-1">
                                <span>Non-DOT</span>
                                <span class="fw-semibold">{{ metrics.dotSplit.nonDotCount }}</span>
                            </li>
                            <li class="d-flex justify-content-between py-1">
                                <span>Unspecified</span>
                                <span class="fw-semibold">{{ metrics.dotSplit.unspecifiedCount }}</span>
                            </li>
                        </ul>
                    }
                </div>
            </div>
        </div>
    </div>

    <div class="row g-3 mt-0">
        <div class="col-lg-6">
            <div class="card h-100">
                <div class="card-body">
                    <h5 class="card-title">Top departments</h5>
                    <p class="small text-muted">Departments with the most accident reports.</p>
                    @if (metrics.topDepartments.length === 0) {
                        <p class="text-muted small mb-0">No reports recorded yet.</p>
                    } @else {
                        <ul class="list-unstyled mb-0">
                            @for (dept of metrics.topDepartments; track dept.department) {
                                <li class="d-flex justify-content-between border-bottom py-1">
                                    <span class="text-truncate me-2">{{ dept.department }}</span>
                                    <span class="fw-semibold">{{ dept.count }}</span>
                                </li>
                            }
                        </ul>
                    }
                </div>
            </div>
        </div>
    </div>
</div>
